// extracted by mini-css-extract-plugin
export default {"complianceServicesWrapper":"styles_complianceServicesWrapper__gzU6M","titleWrapper":"styles_titleWrapper__uLQ+8","contentWrapper":"styles_contentWrapper__RKrZ+"};